import axios from "axios";
import _$ from "1dr-utils/helpers/docReady";

// This spins up once, so multiple things can 'require' it but it's only going to init itself once.
let APP = window.APP || {};
let container;
let ready = false;

const summary = {
  _container: container,
  _getContainer: function (cb) {
    if (typeof APP.summaryUrl === "undefined") {
      return false;
    }

    if (!ready) {
      _$(function () {
        container = document.getElementById("checkoutSummary");
        console.log("Got Summary Container");
        ready = true;
        cb(container);
      });
    } else {
      cb(container);
    }

    return this;
  },

  loading: function () {
    return summary._getContainer(function (container) {
      if (container) {
        container.style.opacity = 0.5;
      }
    });
  },

  ready: function () {
    return summary._getContainer(function (container) {
      if (container) {
        container.style.opacity = 1;
      }
    });
  },

  refresh: function (cb) {
    return summary._getContainer(function (container) {
      let p = axios.create({
        responseType: "text",
      });

      p.get(APP.summaryUrl).then((response) => {
        container.innerHTML = response.data;
        summary.ready();

        if (typeof cb === "function") {
          cb();
        }
      });
    });
  },
};

export default summary;
